import React, { useEffect, useState } from "react";
import styles from "./subregionnavbar.module.scss";
import userDefault from "../../_assets/icons/user.svg";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const SubregionNavbar = () => {
  const location = useLocation();
  const store = useSelector((state) => state);
  const [header, setHeader] = useState("");
  useEffect(() => {
    let header = "";
    switch (location.pathname) {
      case "/containers-stats":
        header = "Containers and SRB's";
        break;
      case "/impact":
        header = "Impact";
        break;
      case "/container-usage":
        header = "Usage";
        break;
      case "/op-reusers":
        header = "Reusers";
        break;
      case "/op-notifications":
        header = "Notifications";
        break;
      default:
        header = "Containers and SRB's";
    }
    setHeader(header);
  }, [location]);

  return (
    <nav className={styles.subregionNavbar}>
      <div className={styles.header}>
        <h2>{header}</h2>
      </div>
      <div className={styles.content}>
        <span className={styles.subregionName}>
          {store?.auth?.user?.subregionName || ""}
        </span>
        <div className={styles.border} />
        <div className={styles.userInfo}>
          <span>{store?.auth?.user?.fullName}</span>
          <img src={userDefault} />
        </div>
      </div>
    </nav>
  );
};

export default SubregionNavbar;
